import Card from "react-bootstrap/Card";
import Badge from "react-bootstrap/Badge";

import Formatter from "/src/lib/formatter";

import he from "he";

const BEDROOM_TYPES = [
  { field: "studio_price", label: "Studio" },
  { field: "1br_price", label: "1BR" },
  { field: "2br_price", label: "2BR" },
  { field: "3br_price", label: "3BR" },
  { field: "4br_price", label: "4BR" },
  { field: "5br_price", label: "5BR" },
  { field: "6br_price", label: "6BR" },
  { field: "penthouse_price", label: "PH" },
];

const style = {
  overlayContainer: {
    position: 'absolute',
    inset: 0
  },
  overlayBackground: {
    zIndex: 1,
    position: 'absolute',
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  overlayBadges: {
    zIndex: 2,
    position: 'relative',
    color: 'white'
  },
  overlayText: {
    zIndex: 2,
    position: 'absolute',
    color: 'white',
    inset: 0
  }
}

const renderNumericRange = (item, { min, max, prefix='', suffix='' }) => {
  if (!item) {
    return;
  }
  if (item[min] === null) {
    return <div>ENQUIRE</div>;
  }
  else if (item[min] === "SOLD OUT") {
    return <div>SOLD OUT</div>;
  }
  else if (item[min] === item[max]) {
    return <div>{prefix}{Formatter.money(item[min])}{suffix}</div>;
  }
  else if (item[min] && !item[max]) {
    return <div>{prefix}{Formatter.money(item[min])}{suffix}</div>;
  }
  else {
    return <div>{prefix}{Formatter.money(item[min])}{suffix} - {prefix}{Formatter.money(item[max])}{suffix}</div>;
  }
}

function Component({ data, ...otherProps }) {

  const renderImageOverlay = () => {

    // listing_source = New or Resale etc (Keep this)
    // availability
    // feature

    let ribbon = [];
    if (data.availability.includes(10)) {
      ribbon.push(
        <div key="availability">
          <div style={style.overlayBackground} className="ribbon-overlay"></div>
          <div style={style.overlayText} className="h-100 d-flex flex-column align-items-center justify-content-center">
            <div className="bg-danger p-2">100% SOLD</div>
          </div>
        </div>
      );
    }
    if (data.ribbon_text) {
      ribbon.push(
        <div key="ribbon_text" style={style.overlayBadges}>
          <div className="project_ribbon_text bg-danger p-1 shadow small fw-bold d-inline-block">
            {data.ribbon_text}
          </div>
        </div>
      );
    }
    if (ribbon.length > 0) {
      return (
        <div style={style.overlayContainer}>
          {ribbon}
        </div>
      );
    }
  }

  const renderBedrooms = () => {
    let types = [];
    for (const item of BEDROOM_TYPES) {
      if (data?.[item.field] > 0) {
        types.push(item.label);
      }
    }
    if (types.length > 0) {
      return (
        <div className="d-flex flex-row">
          {types.map(item => <Badge key={item} bg="light" className="text-dark">{item}</Badge>)}
        </div>
      );
    }
  }

  const renderBadges = () => {
    let badges = [];
    if (data.location) {
      badges.push(
        <Badge key="location" bg="light" className="rounded-0 border-0 text-dark fw-normal">
          {data.location}
        </Badge>
      );
    }
    if (data.tenure) {
      badges.push(
        <Badge key="tenure" bg="light" className="rounded-0 border-0 text-dark fw-normal">
          {data.tenure}
        </Badge>
      );
    }
    if (data.expected_top_year) {
      badges.push(
        <Badge key="expected_top_year" bg="light" className="rounded-0 border-0 text-dark fw-normal">
          TOP {data.expected_top_year}
        </Badge>
      );
    }
    if (badges.length > 0) {
      return (
        <div className="d-flex flex-row align-items-start gap-1">
          {badges}
        </div>
      );
    }
  }

  data.property_prices = data.property_prices || [];

  const totalUnits = data.property_prices.reduce((carry, item) => carry + item.NoOfUnits, 0);
  const totalUnitsSold = data.property_prices.reduce((carry, item) => carry + item.NoOfUnitsSold, 0);
  const percSold = Math.round((totalUnitsSold / totalUnits)*100);
  const isResidential = data.property_prices.filter(item => item.Bedrooms > 0).length || 0;
  const unitTypes = data.property_prices.map(item => item.key);

  const renderPrices = () => {
    const priceLines = [];
    for (const key of unitTypes) {
      const priceItem = data.property_prices.find(item => item.key === key);
      const priceItemPercSold = Math.round((priceItem?.NoOfUnitsSold / priceItem?.NoOfUnits) * 100);
      const name = `${key}` + (key > 0 ? "BR" : "");
      const areaRange = renderNumericRange(priceItem, { min: "MinArea", max: "MaxArea", suffix: " sf" });
      const minPrice = renderNumericRange(priceItem, { min: "MinPrice", prefix: "$" });
      priceLines.push(
        <div key={name}>
          <div key={name} className="d-flex flex-row justify-content-between small">
            <div className="d-flex flex-row gap-1">
              <div>{name}</div>
            </div>
            <div className="d-flex flex-row gap-1">
            <Badge bg="light" className="text-dark fw-normal">{areaRange}</Badge>
              <div>{minPrice}</div>
            </div>
          </div>
          <div className="progress-line" style={{ "--percentage": priceItemPercSold || 0 }}></div>
        </div>
      );
    }
    return (
      <div className="project_prices d-flex flex-column gap-1">{priceLines}</div>
    )
  }

  const renderLeftColumn = () => {
    return (
      <div className="d-flex flex-column gap-1">
        <div className="d-flex flex-row justify-content-between">
          <div className="project_title fw-bold">{he.decode(data.title?.rendered)}</div>
        </div>
        <div className="d-flex flex-column align-items-start gap-1">
          <Badge bg="light" className="rounded-0 border-0 text-dark fw-normal">{data.property_type}</Badge>
        </div>
        {renderBadges()}
        {/*renderBedrooms()*/}
      </div>
    );
  }

  const renderRightColumn = () => {
    if (percSold >= 0) {
      return (
        <div className="d-flex flex-column" style={{ minWidth: 30 }}>
          <div className="donut-wrap" style={{ "--size": "30px", "--percentage": percSold }}>
            <div className="donut-ring" aria-hidden="true"></div>
            <div className="donut-label">{percSold}%</div>
          </div>
        </div>
      );
    }
  }

  const renderImage = () => {
    if (data.featured_media_url__medium_large) {
      return (
        <Card.Img variant="top" loading="lazy" src={data.featured_media_url__medium_large} />
      );
    }
  }

  //xl={3} lg={4} md={4} sm={6} xs={6}
  return (
    <Card {...otherProps}>
      <div className="position-relative">
        {renderImageOverlay()}
        {renderImage()}
      </div>
      <Card.Body className="d-flex flex-column gap-1">
        <div className="d-flex flex-row justify-content-between gap-1">
          {renderLeftColumn()}
          {renderRightColumn()}
        </div>
        <div></div>
        {renderPrices()}
      </Card.Body>
    </Card>
  );

}

export default Component;
